import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { UploadLinkListFields } from '../../fragments/generated/UploadLinkListFields';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetFolderUploadLinksQueryVariables = Types.Exact<{
  folderId: Types.Scalars['ID']['input'];
  page: Types.PageInput;
}>;


export type GetFolderUploadLinksQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id: string, asset?: { __typename?: 'AudioAsset', id: string } | { __typename?: 'DocumentAsset', id: string } | { __typename?: 'FileAsset', id: string } | { __typename?: 'FolderAsset', id: string, uploadLinks?: { __typename?: 'UploadLinkConnection', totalCount: number, nodes: Array<{ __typename?: 'UploadLink', id?: string | null, name?: string | null, url?: string | null, creator?: { __typename?: 'AuthenticatedUser', id: string, name?: string | null } | null }> } | null } | { __typename?: 'ImageAsset', id: string } | { __typename?: 'InteractiveAsset', id: string } | { __typename?: 'InteractiveLiveAsset', id: string } | { __typename?: 'ModelAsset', id: string } | { __typename?: 'UnsupportedAsset', id: string } | { __typename?: 'VersionStackAsset', id: string } | { __typename?: 'VideoAsset', id: string } | null } | null };


export const GetFolderUploadLinks = /*#__PURE__*/ gql`
    query GetFolderUploadLinks($folderId: ID!, $page: PageInput!) @stewardship(stewards: [VIEWER]) {
  account(by: {assetId: $folderId}) {
    id
    asset(id: $folderId) {
      id
      ... on FolderAsset {
        id
        uploadLinks(page: $page) {
          totalCount
          nodes {
            ...UploadLinkListFields
          }
        }
      }
    }
  }
}
    ${UploadLinkListFields}` as unknown as DocumentNode<GetFolderUploadLinksQuery, GetFolderUploadLinksQueryVariables>;

          

          export const useGetFolderUploadLinksQuery = (options?:QueryHookOptions<GetFolderUploadLinksQuery, GetFolderUploadLinksQueryVariables>) => useQuery(GetFolderUploadLinks, options);

          

          export type GetFolderUploadLinksQueryOptions = QueryHookOptions<GetFolderUploadLinksQuery, GetFolderUploadLinksQueryVariables>;

          

          export const useGetFolderUploadLinksLazyQuery = (options?:LazyQueryHookOptions<GetFolderUploadLinksQuery, GetFolderUploadLinksQueryVariables>) => useLazyQuery(GetFolderUploadLinks, options);

          

          export type GetFolderUploadLinksQueryResult = ReturnType<typeof useGetFolderUploadLinksQuery>;

          
